import { connect } from 'react-redux';
import React from 'react';
import { Button } from 'module-tsl-ui-elements';
import { setup as setupMz, emitPageView } from '../../modules/Mz';
import { getMoreReviews, getReviewReasons } from '../../modules/ReviewsModule';
import BaseComponent from './BaseComponent';
import ReviewCard from './review/ReviewCard';
import ReviewsHeader from './review/ReviewsHeader';

@connect((state) => ({
  items: state.reviewsModule.reviews,
  loaded: state.reviewsModule.reviewsLoaded,
  allLoaded: state.reviewsModule.reviewsAllLoaded,
  isAuthenticated: state.profileModule.isAuthenticated,
  userReviews: state.reviewsModule.userReviews,
  reviewErrors: state.reviewsModule.reviewErrors,
  hasAccessForReviews: state.profileModule.hasAccessForReviews,
}), { getMoreReviews, setupMz, emitPageView, getReviewReasons })
export default class Reviews extends BaseComponent {
  get resourcesOnTop() {
    return this.props.location.query.resources || '';
  }

  componentWillMount() {
    this.props.getReviewReasons();
  }

  componentDidMount() {
    if ((this.props.isAuthenticated || this.props.hasAccessForReviews) && this.props.items.length === 0) {
      this.props.getMoreReviews({ resourcesOnly: this.resourcesOnTop });
    }

    if (window.TES.isTestGroup === 'true') {
      this.props.setupMz('resource.dash-thumbs-reviews');
    } else {
      this.props.setupMz('resource.dash-reviews');
    }

    if (!window.emitPageView) return window.emitPageView = true; // eslint-disable-line no-return-assign
    this.props.emitPageView();
  }

  getMoreReviews() {
    this.props.getMoreReviews({ ignoreResources: this.resourcesOnTop });
  }

  render() {
    const { loaded, items, allLoaded } = this.props;
    const bodyLoading = (
      <div className="text-center my-2">
        <Button loading>Loading</Button>
      </div>
    );
    const bodyWithItems = this.props.items.map((item) => <ReviewCard key={item.resource._id} resource={item.resource} error={this.props.reviewErrors[item.resource._id]} review={this.props.userReviews[item.resource._id]} reviewed={item.review} />); // eslint-disable-line no-underscore-dangle
    if (!loaded) bodyWithItems.push(bodyLoading);
    const bodyNoItems = loaded ? (<div className="dashboard-card__container" key={'no-content'}>
      You don't have any resources to be displayed here.
    </div>) : bodyLoading;
    const body = (items && items.length) ? bodyWithItems : bodyNoItems;
    document.title = 'My reviews - teaching resources - Tes';
    return (
      <div className="container-fluid-max user-dashboard-reviews">
        <div className="row">
          <div className="tes-panel">
            <ReviewsHeader />
            {body}
            {!allLoaded && loaded && <div className="text-center pb-2">
              <Button
                theme="secondary"
                onClick={this.getMoreReviews.bind(this)}
              >
                  Show more
              </Button>
            </div>}
          </div>
        </div>
      </div>
    );
  }
}
